import React from 'react';
import { type ReviewsBadge } from '@gql/schema';
import {
  HighlightsBadge,
  HighlightsBadgeSize,
  Icon,
  IconScale,
  Typography,
  TypographyVariant,
} from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useApplicationState } from '@utils/useApplicationState';
import { useTranslations } from '@utils/useTranslations';
import { Container, TYLogoContainer } from './PropertyHighlightsBadges.styles';
import { transformIconName } from './PropertyHighlightsBadges.utils';
import { TYLogo } from './TYLogo';

interface Props {
  propertyHighlights: ReviewsBadge[];
}

export const PropertyHighlightsBadges = ({ propertyHighlights }: Props) => {
  const { isMobile } = useApplicationState();
  const { translations } = useTranslations();

  if (!propertyHighlights?.length) {
    return null;
  }

  return (
    <Container isMobile={!!isMobile}>
      {propertyHighlights.map(highlight => (
        <HighlightsBadge
          key={highlight.text}
          text={highlight?.text ?? ''}
          subText={highlight?.subtext ?? ''}
          icon={<Icon name={transformIconName(highlight?.categoryId)} size={IconScale.l} />}
          size={isMobile ? HighlightsBadgeSize.SMALL : HighlightsBadgeSize.LARGE}
        />
      ))}
      {propertyHighlights.length ? (
        <TYLogoContainer isMobile={!!isMobile}>
          <Typography variant={TypographyVariant.micro}>
            {i18n('sale.powered.by', [], translations)}
          </Typography>
          <TYLogo />
        </TYLogoContainer>
      ) : null}
    </Container>
  );
};
